import {createFeature, createReducer, createSelector, on} from '@ngrx/store';
import {EntityState, EntityAdapter, createEntityAdapter} from '@ngrx/entity';
import {ItineraryModel} from "../models/itinerary.model";
import {ItinerariesActions, ItinerariesAPiActions, ItinerariesChannelActions} from "./itineraries.action";
export interface ItineraryState extends EntityState<ItineraryModel> {
}

const adapter: EntityAdapter<ItineraryModel> = createEntityAdapter<ItineraryModel>();

const initialState: ItineraryState = adapter.getInitialState();

const reducer = createReducer(
  initialState,

  on(ItinerariesChannelActions.notificationReceived, (state, {notification}) => {
    if (state.entities[notification.id]?.updatedAt < notification.updatedAt) {
      return adapter.setOne(notification, state);
    } else {
      return state;
    }
  }),

  on(ItinerariesActions.setMany, (state, {itineraries}) =>
    adapter.setMany(itineraries, state)
  ),

  on(ItinerariesActions.setOne, (state, {itinerary}) =>
    adapter.setOne(itinerary, state)
  ),

  on(ItinerariesAPiActions.getItinerariesSuccess, (state, {itineraries}) =>
    adapter.setMany(itineraries, state)
  ),

  on(ItinerariesActions.removeByIds, (state, {ids}) => adapter.removeMany(ids, state)),

  on(ItinerariesActions.removeAll, () => ({...initialState}))
);

export const itinerariesFeature = createFeature({
  name: 'Itineraries',
  reducer,
  extraSelectors: ({
                     selectEntities,
                   }) => ({
    selectItineraries: () => createSelector(
      selectEntities,
      (entities) => Object.values(entities),
    ),
    selectItinerary: (id: string) => createSelector(
      selectEntities,
      (entities) => entities[id],
    )
  }),
});

